import { Search } from "@/types/types";
import styles from "../more-filters-component.module.css";

export default function View({
  t,
  updateSearch,
  filters,
}: {
  t: any;
  updateSearch: <K extends keyof Search>(
    key: K,
    value: Search[K]
  ) => Promise<void>;
  filters: Search;
}) {
  return (
    <div className={`${styles.filterGroup} ${styles.selectors}`}>
      <fieldset className={styles.fieldSet}>
        <legend className={styles.legend}>{t("viewTitle")}</legend>
        <ul className={styles.viewGrid}>
          <li>
            <button
              onClick={async (e) => {
                e.preventDefault();
                await updateSearch("sea_view", !filters.sea_view);
              }}
              className={`${styles.facility} ${styles.viewfacility} ${
                filters.sea_view ? styles.facilityActive : ""
              }`}
              aria-pressed={false}
            >
              <img
                src={
                  "https://d1ktxmigjvpff7.cloudfront.net/view-icons/sea_view.png"
                }
              />
              {t("sea-view")}
            </button>
          </li>
          <li>
            <button
              onClick={async (e) => {
                e.preventDefault();
                await updateSearch("mountain_view", !filters.mountain_view);
              }}
              className={`${styles.facility} ${styles.viewfacility} ${
                filters.mountain_view ? styles.facilityActive : ""
              }`}
              aria-pressed={false}
            >
              <img
                src={
                  "https://d1ktxmigjvpff7.cloudfront.net/view-icons/mountain_view.png"
                }
              />
              {t("mountain-view")}
            </button>
          </li>
          <li>
            <button
              onClick={async (e) => {
                e.preventDefault();
                await updateSearch(
                  "countryside_view",
                  !filters.countryside_view
                );
              }}
              className={`${styles.facility} ${styles.viewfacility} ${
                filters.countryside_view ? styles.facilityActive : ""
              }`}
              aria-pressed={false}
            >
              <img
                src={
                  "https://d1ktxmigjvpff7.cloudfront.net/view-icons/countryside_view.png"
                }
              />
              {t("countryside-view")}
            </button>
          </li>
          <li>
            <button
              onClick={async (e) => {
                e.preventDefault();
                await updateSearch("city_view", !filters.city_view);
              }}
              className={`${styles.facility} ${styles.viewfacility} ${
                filters.city_view ? styles.facilityActive : ""
              }`}
              aria-pressed={false}
            >
              <img
                src={
                  "https://d1ktxmigjvpff7.cloudfront.net/view-icons/city_view.png"
                }
              />
              {t("city-view")}
            </button>
          </li>
        </ul>
      </fieldset>
    </div>
  );
}
